var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};if(global.Proxy){
module.exports=_extends({},
require('./es6Remx'),{
__versionType:'es6'});

}else{
module.exports=_extends({},
require('./legacyRemx'),{
__versionType:'legacy'});

}